import type { MenuDetail, MenuSummary, SeasonKey } from '../../../shared/domain';
import type { LocalizationLanguageTag } from '../../../shared/culinary-locales';
import type { LanguageProfile } from '../../../shared/localization';
import { jsonBody, requestJson } from '../../shared/api-client';

export interface MenuLocalizationPayload {
  title: string;
  seasonLabel: string;
  description: string;
  items: Array<{ itemId: string; courseLabel: string; displayName: string; note: string }>;
}

export interface MenuDraftPayload {
  revision: number; title: string; seasonLabel: string; year: number | null; seasonKey: SeasonKey | null; description: string;
  items: Array<{ itemId: string; dishVersionId: string; courseLabel: string; displayName: string; note: string }>;
}

export const menuApi = {
  list: () => requestJson<{ menus: MenuSummary[] }>('/api/menus'),
  detail: (id: string) => requestJson<{ menu: MenuDetail }>(`/api/menus/${encodeURIComponent(id)}`),
  create: (name: string) => requestJson<{ id: string }>('/api/menus', jsonBody('POST', { name })),
  save: (id: string, input: MenuDraftPayload) => requestJson<{ ok: true }>(`/api/menus/${encodeURIComponent(id)}/draft`, jsonBody('PATCH', input)),
  localizationConfig: () => requestJson<{ configured: boolean }>('/api/menus/localization-config'),
  generateLocalization: (id: string, versionId: string, language: LocalizationLanguageTag) =>
    requestJson<{ ok: true }>(`/api/menus/${encodeURIComponent(id)}/versions/${encodeURIComponent(versionId)}/localizations/${encodeURIComponent(language)}/generate`, jsonBody('POST', {})),
  publish: (id: string, revision: number) => requestJson<{ ok: true }>(`/api/menus/${encodeURIComponent(id)}/publish`, jsonBody('POST', { revision })),
  revise: (id: string) => requestJson<{ id: string }>(`/api/menus/${encodeURIComponent(id)}/revise`, jsonBody('POST', {})),
  localize: (id: string, versionId: string, language: LocalizationLanguageTag, input: MenuLocalizationPayload) =>
    requestJson<{ ok: true }>(`/api/menus/${encodeURIComponent(id)}/versions/${encodeURIComponent(versionId)}/localizations/${encodeURIComponent(language)}`, jsonBody('PATCH', input)),
  deleteLocalization: (menuId: string, versionId: string, language: LocalizationLanguageTag) => requestJson<{ ok: true }>(`/api/menus/${encodeURIComponent(menuId)}/versions/${encodeURIComponent(versionId)}/localizations/${encodeURIComponent(language)}`, { method: 'DELETE' }),
  copy: (id: string, versionId: string, languageProfile: LanguageProfile = 'original') => requestJson<{ text: string }>(`/api/menus/${encodeURIComponent(id)}/copy`, jsonBody('POST', { versionId, languageProfile }))
};
